<template>
    <div class="col-md-12" style="overflow : auto">
        <LinkStatus />
        <br />
        <b-tabs>
            <br />
            <b-tab title="Documents">
                <b-tabs pills cards>
                    <b-tab title="Search">
                        <Documents />
                    </b-tab>
                    <b-tab title="Document With Classification">
                        <DocsWClassification />
                    </b-tab>
                    <b-tab v-if="$store.getters.CRAD" title="Encoded By Document">
                        <DocsWEncoded />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New Document">
                        <DocEncode />
                    </b-tab>
                    <b-tab v-if="!$store.getters.CRAD && !$store.getters.VIEWER"
                           title="My Data">
                        <Encodes />
                    </b-tab>
                </b-tabs>
            </b-tab>

            <b-tab title="Persons">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <Persons />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New Person">
                        <PersonEncode />
                    </b-tab>
                </b-tabs>
            </b-tab>

            <b-tab title="Organizations">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <Organizations />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New Organization">
                        <OrganizationEncode />
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab title="Events">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <Events />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New Event">
                        <EventsEncode />
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab title="Financial">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <financial />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New Financial Resources">
                        <financialEncode />
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab title="FireArms">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <firearms />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New FireArms">
                        <firearmEncode />
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab title="LegalCharges">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <legal />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New Legal Charge">
                        <legalEncode />
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab title="RealEstate">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <realestate />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New RealEstate">
                        <realestateEncodes />
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab title="Telephone">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <telephone />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New Telephone">
                        <telephoneEncode />
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab title="OfficialPapers">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <paper />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New Official Paper">
                        <paperEncode />
                    </b-tab>
                </b-tabs>
            </b-tab>
            <b-tab title="Transportation">
                <b-tabs pills card>
                    <b-tab title="Search">
                        <transportation />
                    </b-tab>
                    <b-tab v-if="!$store.getters.VIEWER" title="New Transportation">
                        <transportationEncode />
                    </b-tab>
                </b-tabs>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
    import Documents from "./Document";
    import DocsWClassification from './DocumentWClassification'
    import DocEncode from "./encodes/DocumentsEncode";
    import Persons from "./Person";
    import PersonEncode from "./encodes/PersonEncode";
    import Organizations from "./Organization";
    import OrganizationEncode from "./encodes/OrganizationEncode";
    import Events from "./Event";
    import EventsEncode from "./encodes/EventsEncode";
    import financial from "./FinalcialResources.vue";
    import financialEncode from "./encodes/FinancialEncode";
    import firearms from "./FireArms.vue";
    import firearmEncode from "./encodes/FireArmsEncode";
    import legal from "./LegalCharges.vue";
    import legalEncode from "./encodes/LegalChargesEncode";
    import paper from "./Papers.vue";
    import paperEncode from "./encodes/PaperEncode";
    import realestate from "./RealEstate.vue";
    import realestateEncodes from "./encodes/RealEstateEncode";
    import telephone from "./Telephone.vue";
    import telephoneEncode from "./encodes/TelephoneEncode";
    import transportation from "./Transportation.vue";
    import transportationEncode from "./encodes/TransportationEncode";
    import LinkStatus from "./master/LinkStatus";
    import Encodes from "./RegionalData";
    import DocsWEncoded from './DocsWEncoded'
    export default {
        components: {
            DocEncode,
            Encodes,
            Documents,
            DocsWClassification,
            Persons,
            PersonEncode,
            Organizations,
            OrganizationEncode,
            Events,
            financial,
            financialEncode,
            EventsEncode,
            firearms,
            firearmEncode,
            legal,
            legalEncode,
            realestate,
            telephone,
            telephoneEncode,
            paper,
            paperEncode,
            transportation,
            transportationEncode,
            realestateEncodes,
            LinkStatus,
            DocsWEncoded
        },
    };
</script>
